export default "__VITE_ASSET__Cp4JGOB6__"